/**
 * 模板列表-底部状态
 * @author VenDream
 * @since 17/11/1
 */
import React from 'react';
import PropTypes from 'prop-types';
import { isShowRabbitpre, isRabbitpreEnv } from 'utils/env';

const logo = require('assets/images/loading-logo.png');
import './bottom-status.less';

export default function BottomStatus(props) {
  const { status } = props;
  const showRabbitpreLogo = isShowRabbitpre();
  let content = '';

  switch (status) {
    case 0:
      content = null;
      break;
    case 1:
      content = (
        <div>
          {isRabbitpreEnv() && showRabbitpreLogo ? (
            <img src={logo} alt="LOADING_LOGO" className="loading-logo" />
          ) : null}
          <span className="loading-text loading">努力加载中......</span>
        </div>
      );
      break;
    case 2:
      content = (
        <div>
          {isRabbitpreEnv() && showRabbitpreLogo ? (
            <img src={logo} alt="LOADING_LOGO" className="loading-logo" />
          ) : null}
          <span className="loading-text loading">加载失败，请刷新重试</span>
        </div>
      );
      break;
    case 3:
      content = (
        <div>
          <span className="loading-text ended">—— 没有更多数据了 ——</span>
        </div>
      );
      break;
    default:
      break;
  }

  return <div className="bottom-status">{content}</div>;
}

BottomStatus.propTypes = {
  // 模板市场加载状态
  status: PropTypes.number,
};
